const getTokenLogoURL = (address: string) =>
  `${window.location.origin}/images/tokens/${address}.png`

export default getTokenLogoURL
